import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import noop from '@gik/core/utils/noop';
import InkindUserUpdateTimelineCard from '@gik/inkind-page/components/InkindUserUpdateTimelineCard/InkindUserUpdateTimelineCard';
import { useUserUpdatesStore } from '@gik/inkind-page/store/UserUpdatesStore';
import InkindUserUpdate from '@gik/inkind-page/models/InkindUserUpdate';
import { scroller } from 'react-scroll';

export interface IInkindUserUpdatesTimelineModalProps {
  openEditUpdateModal(update: InkindUserUpdate): void;

  isOrganizer: boolean;
  selectedUpdate?: InkindUserUpdate;

  onDeleteUpdate?(): void;
}

export const InkindUserUpdatesTimelineModalBlockName = 'inkind-user-updates-timeline-modal';

export default function InkindUserUpdatesTimelineModal({
  openEditUpdateModal = noop,
  isOrganizer,
  selectedUpdate,
  onDeleteUpdate = noop,
}: IInkindUserUpdatesTimelineModalProps) {
  const bem = useBemCN(InkindUserUpdatesTimelineModalBlockName);
  const updates = useUserUpdatesStore(state => state.updates);

  React.useEffect(() => {
    if (selectedUpdate) {
      scroller.scrollTo(`timeline-card-${selectedUpdate.id}`, {
        spy: true,
        smooth: true,
        containerId: InkindUserUpdatesTimelineModalBlockName,
      });
    }
  }, [selectedUpdate]);

  return (
    <div {...bem()}>
      <div {...bem('cards')}>
        {updates.map(update => (
          <InkindUserUpdateTimelineCard
            key={update.id}
            openEditUpdateModal={openEditUpdateModal}
            update={update}
            isOrganizer={isOrganizer}
            onDeleteUpdate={onDeleteUpdate}
          />
        ))}
      </div>
    </div>
  );
}
